import { AUTH_ENDPOINTS } from './authEndpoints';

const CARDS_ROOT = '/cards';
const CARDS_MANAGE_ROOT = `${CARDS_ROOT}/manage`;

export const API_ENDPOINTS = {
  auth: AUTH_ENDPOINTS,
  config: {
    get: '/config/get',
  },
  cards: {
    view: {
      getAll: `${CARDS_ROOT}/view/get-all`,
      getById: `${CARDS_ROOT}/view/get-by-id`,
      getDepositOperations: `${CARDS_ROOT}/view/get-deposit-operations`,
      revealSecretData: `${CARDS_ROOT}/view/reveal-secret-data`,
    },
    manage: {
      create: `${CARDS_MANAGE_ROOT}/create`,
      getDepositAddress: `${CARDS_MANAGE_ROOT}/get-deposit-address`,
      updateDetails: `${CARDS_MANAGE_ROOT}/update-card-details`,
      updatePinCode: `${CARDS_MANAGE_ROOT}/update-card-pin-code`,
      updateStatus: `${CARDS_MANAGE_ROOT}/update-card-status`,
    },
  },
  exchangeRates: {
    getAll: '/exchange-rates/get-all',
    calculateByAmount: '/exchange-rates/calculate-rate-by-amount',
  },
  currencies: {
    getAll: '/currencies/get-all',
  },
  operations: {
    getFilters: '/operations/get-filters',
    getAll: '/operations/get-all',
    getById: '/operations/get-by-id',
    getCsvFile: '/operations/get-csv-file',
  },
  legalDocuments: {
    getActive: '/legal-documents/get-active',
    getExact: '/legal-documents/get-exact',
  },
  permissions: {
    csrfMap: '/permissions/csrf-map',
  },
};
